import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UiTooltip, UiPopover } from 'ui-components';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSupportMenu } from 'store';
import Feedback from '../feedback/Feedback';
import { StyledUiIcon } from './styles';

const SupportMenu = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isSupportMenuVisible = useSelector(
    (state) => state.pageReducer.isSupportMenuVisible
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setAnchorEl(buttonRef.current);
  }, []);

  const handleClose = () => {
    if (isSupportMenuVisible) {
      setAnchorEl(null);
      dispatch(toggleSupportMenu({ isVisible: false }));
    }
  };

  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(toggleSupportMenu());
  };

  return (
    <div className='support-menu' data-testid='header-customer-service'>
      <UiPopover
        id={isSupportMenuVisible ? 'supportMenuPopover' : ''}
        open={isSupportMenuVisible}
        anchorEl={anchorEl}
        onClose={handleClose}
        paperStyles={{ marginTop: '25px', width: '320px' }}
      >
        <div className='container'>
          <Feedback toggleHamburger={handleToggle} />
        </div>
      </UiPopover>
      <UiTooltip title={t('support:pageTitle')}>
        <StyledUiIcon
          icon='ri-customer-service-2-line'
          color='#9CAEBB'
          hover='#9CAEBB'
          className='pointer'
          size={20}
          onClick={handleToggle}
          ref={buttonRef}
        />
      </UiTooltip>
    </div>
  );
};

export default SupportMenu;
